import { useState } from "react";

type SearchProps = {
  onSearch: (query: string) => void;
}

const Search: React.FC<SearchProps> = ({ onSearch }) => { 
  const [searchQuery, setSearchQuery] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchQuery(query);
  }

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearch(searchQuery); 
  };

  return (
    <div className="single-widgets widget_search">
      <form onSubmit={handleFormSubmit}>
        <div className="wp-block-search__inside-wrapper ">
          <input
            type="search"
            id="wp-block-search__input-1"
            className="wp-block-search__input"
            name="s"
            value={searchQuery}
            onChange={handleInputChange}
            placeholder="Search Here"
          />
          <button
            type="submit"
            className="wp-block-search__button primary-btn3"
          >
            Search
          </button>
        </div>
      </form>
    </div>
  );
};

export default Search;
